import { useQuery } from "@tanstack/react-query";
import moment from "moment-timezone";
import { fetchApiGet } from "../../../utils";
import { TtOrderEvent, TTOrdersQuery } from "./types";

export function useListTTOrders(queryParams: TTOrdersQuery, options?: { enabled?: boolean }) {
    const params = new URLSearchParams();
    if (queryParams.event_types) {
        queryParams.event_types.forEach((type) => params.append("event_types", type));
    }
    if (queryParams.start_date) {
        params.append("start_date", moment(queryParams.start_date).format("YYYY-MM-DD"));
    }
    if (queryParams.end_date) {
        params.append("end_date", moment(queryParams.end_date).format("YYYY-MM-DD"));
    }

    return useQuery({
        queryKey: ["risk", "brokerage", "tt", "orders", queryParams],
        queryFn: () => fetchApiGet<{ events: TtOrderEvent[] }>("/brokerage/tt/events/orders", params),
        enabled: options?.enabled ?? true,
    });
}

export function useGetOrderEventsByGuid(guidOrderId: string, options?: { enabled?: boolean }) {
    return useQuery({
        queryKey: ["risk", "brokerage", "tt", "orders", "byGuid", guidOrderId],
        queryFn: () => fetchApiGet<{ events: TtOrderEvent[]; guid_order_id: string }>(
            `/brokerage/tt/events/orders/byGuidOrderId/${encodeURIComponent(guidOrderId)}`
        ),
        enabled: (options?.enabled ?? true) && !!guidOrderId,
    });
}
